// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { mvpApiCheckDeviceValidity, mvpApiCloneReviewTasks, mvpApiCompleteJob, mvpApiCompleteJobTask, mvpApiCreateBenchmarkJobs, mvpApiCreateCharger, mvpApiCreateDevice, mvpApiCreateJob, mvpApiCreateJobTasks, mvpApiCreatePlanogram, mvpApiCreatePlanogramImages, mvpApiCreateReviewTasks, mvpApiCreateVideo, mvpApiCreateVideoExportRequest, mvpApiCreateVideoTagName, mvpApiCreateVideoTimeTag, mvpApiDeleteVideoTimeTag, mvpApiErrorOutJob, mvpApiGetBenchmarkJobMetrics, mvpApiGetCompany, mvpApiGetDevicesInventory, mvpApiGetImageGalleryUrls, mvpApiGetImageRotation, mvpApiGetImageUrls, mvpApiGetInjectionPoolStatus, mvpApiGetJob, mvpApiGetJobFile, mvpApiGetJobLogTail, mvpApiGetJobTask, mvpApiGetJobTaskParcels, mvpApiGetMyInjectedBenchmarkMetrics, mvpApiGetNextPendingJobTask, mvpApiGetOosEventBatch, mvpApiGetOosEventFromBuffer, mvpApiGetOosParcel, mvpApiGetPlanogram, mvpApiGetPlanogramImage, mvpApiGetPlanogramLabel, mvpApiGetSignedImageUrl, mvpApiGetSingleImageUrls, mvpApiGetStore, mvpApiGetStoresInventory, mvpApiGetVideo, mvpApiGetVideoExportRequest, mvpApiGetVideoTagName, mvpApiGetVideoTagsForStore, mvpApiGetVideoTimeTag, mvpApiListAllJobTasks, mvpApiListChargers, mvpApiListCompanies, mvpApiListCvUpdateRequests, mvpApiListCvUpdateResponses, mvpApiListDevicePings, mvpApiListDevices, mvpApiListInjectedBenchmarkMetrics, mvpApiListJobs, mvpApiListJobsInFlight, mvpApiListJobTasks, mvpApiListMyBenchmarkJobs, mvpApiListOosEventBatches, mvpApiListOosEventBuffer, mvpApiListOosParcels, mvpApiListPlanogramImages, mvpApiListPlanograms, mvpApiListStorePings, mvpApiListStorePongs, mvpApiListStores, mvpApiListToolWebsites, mvpApiListVideoCaptures, mvpApiListVideoExports, mvpApiListVideoJobs, mvpApiListVideos, mvpApiListVideoTagNames, mvpApiListVideoTimeTags, mvpApiMarkStartedJob, mvpApiRefreshStoreDevices, mvpApiRegisterImages, mvpApiRegisterVideoImages, mvpApiShouldShowStaffTool, mvpApiSignImgixUrl, mvpApiSkipJobTask, mvpApiStopJob, mvpApiTaskActivity, mvpApiUpdateCharger, mvpApiUpdateDevice, mvpApiUpdateJob, mvpApiUpdateJobStage, mvpApiUpdateJobTaskMetadata, mvpApiUpdatePlanogramLabel, mvpApiUpdateStore, mvpApiUpdateVideoPropertyData, mvpApiUpdateVideoStatus, mvpApiUpdateVideoTagName, mvpApiUpdateVideoTags, type Options } from '../sdk.gen';
import type { MvpApiCheckDeviceValidityData, MvpApiCheckDeviceValidityResponse, MvpApiCloneReviewTasksData, MvpApiCloneReviewTasksResponse, MvpApiCompleteJobData, MvpApiCompleteJobResponse, MvpApiCompleteJobTaskData, MvpApiCompleteJobTaskResponse, MvpApiCreateBenchmarkJobsData, MvpApiCreateBenchmarkJobsResponse, MvpApiCreateChargerData, MvpApiCreateChargerResponse, MvpApiCreateDeviceData, MvpApiCreateDeviceResponse, MvpApiCreateJobData, MvpApiCreateJobResponse, MvpApiCreateJobTasksData, MvpApiCreateJobTasksResponse, MvpApiCreatePlanogramData, MvpApiCreatePlanogramImagesData, MvpApiCreatePlanogramImagesResponse, MvpApiCreatePlanogramResponse, MvpApiCreateReviewTasksData, MvpApiCreateReviewTasksResponse, MvpApiCreateVideoData, MvpApiCreateVideoExportRequestData, MvpApiCreateVideoExportRequestResponse, MvpApiCreateVideoTagNameData, MvpApiCreateVideoTagNameResponse, MvpApiCreateVideoTimeTagData, MvpApiCreateVideoTimeTagResponse, MvpApiDeleteVideoTimeTagData, MvpApiDeleteVideoTimeTagResponse, MvpApiErrorOutJobData, MvpApiErrorOutJobResponse, MvpApiGetBenchmarkJobMetricsData, MvpApiGetBenchmarkJobMetricsResponse, MvpApiGetCompanyData, MvpApiGetCompanyResponse, MvpApiGetDevicesInventoryData, MvpApiGetDevicesInventoryResponse, MvpApiGetImageGalleryUrlsData, MvpApiGetImageGalleryUrlsResponse, MvpApiGetImageRotationData, MvpApiGetImageRotationResponse, MvpApiGetImageUrlsData, MvpApiGetImageUrlsResponse, MvpApiGetInjectionPoolStatusData, MvpApiGetInjectionPoolStatusResponse, MvpApiGetJobData, MvpApiGetJobFileData, MvpApiGetJobFileResponse, MvpApiGetJobLogTailData, MvpApiGetJobLogTailResponse, MvpApiGetJobResponse, MvpApiGetJobTaskData, MvpApiGetJobTaskParcelsData, MvpApiGetJobTaskParcelsResponse, MvpApiGetJobTaskResponse, MvpApiGetMyInjectedBenchmarkMetricsData, MvpApiGetMyInjectedBenchmarkMetricsResponse, MvpApiGetNextPendingJobTaskData, MvpApiGetNextPendingJobTaskResponse, MvpApiGetOosEventBatchData, MvpApiGetOosEventBatchResponse, MvpApiGetOosEventFromBufferData, MvpApiGetOosEventFromBufferResponse, MvpApiGetOosParcelData, MvpApiGetOosParcelResponse, MvpApiGetPlanogramData, MvpApiGetPlanogramImageData, MvpApiGetPlanogramImageResponse, MvpApiGetPlanogramLabelData, MvpApiGetPlanogramLabelResponse, MvpApiGetPlanogramResponse, MvpApiGetSignedImageUrlData, MvpApiGetSignedImageUrlResponse, MvpApiGetSingleImageUrlsData, MvpApiGetSingleImageUrlsResponse, MvpApiGetStoreData, MvpApiGetStoreResponse, MvpApiGetStoresInventoryData, MvpApiGetStoresInventoryResponse, MvpApiGetVideoData, MvpApiGetVideoExportRequestData, MvpApiGetVideoExportRequestResponse, MvpApiGetVideoResponse, MvpApiGetVideoTagNameData, MvpApiGetVideoTagNameResponse, MvpApiGetVideoTagsForStoreData, MvpApiGetVideoTagsForStoreResponse, MvpApiGetVideoTimeTagData, MvpApiGetVideoTimeTagResponse, MvpApiListAllJobTasksData, MvpApiListAllJobTasksResponse, MvpApiListChargersData, MvpApiListChargersResponse, MvpApiListCompaniesData, MvpApiListCompaniesResponse, MvpApiListCvUpdateRequestsData, MvpApiListCvUpdateRequestsResponse, MvpApiListCvUpdateResponsesData, MvpApiListCvUpdateResponsesResponse, MvpApiListDevicePingsData, MvpApiListDevicePingsResponse, MvpApiListDevicesData, MvpApiListDevicesResponse, MvpApiListInjectedBenchmarkMetricsData, MvpApiListInjectedBenchmarkMetricsResponse, MvpApiListJobsData, MvpApiListJobsInFlightData, MvpApiListJobsInFlightResponse, MvpApiListJobsResponse, MvpApiListJobTasksData, MvpApiListJobTasksResponse, MvpApiListMyBenchmarkJobsData, MvpApiListMyBenchmarkJobsResponse, MvpApiListOosEventBatchesData, MvpApiListOosEventBatchesResponse, MvpApiListOosEventBufferData, MvpApiListOosEventBufferResponse, MvpApiListOosParcelsData, MvpApiListOosParcelsResponse, MvpApiListPlanogramImagesData, MvpApiListPlanogramImagesResponse, MvpApiListPlanogramsData, MvpApiListPlanogramsResponse, MvpApiListStorePingsData, MvpApiListStorePingsResponse, MvpApiListStorePongsData, MvpApiListStorePongsResponse, MvpApiListStoresData, MvpApiListStoresResponse, MvpApiListToolWebsitesData, MvpApiListToolWebsitesResponse, MvpApiListVideoCapturesData, MvpApiListVideoCapturesResponse, MvpApiListVideoExportsData, MvpApiListVideoExportsResponse, MvpApiListVideoJobsData, MvpApiListVideoJobsResponse, MvpApiListVideosData, MvpApiListVideosResponse, MvpApiListVideoTagNamesData, MvpApiListVideoTagNamesResponse, MvpApiListVideoTimeTagsData, MvpApiListVideoTimeTagsResponse, MvpApiMarkStartedJobData, MvpApiMarkStartedJobResponse, MvpApiRefreshStoreDevicesData, MvpApiRegisterImagesData, MvpApiRegisterVideoImagesData, MvpApiShouldShowStaffToolData, MvpApiShouldShowStaffToolResponse, MvpApiSignImgixUrlData, MvpApiSignImgixUrlResponse, MvpApiSkipJobTaskData, MvpApiSkipJobTaskResponse, MvpApiStopJobData, MvpApiStopJobResponse, MvpApiTaskActivityData, MvpApiTaskActivityResponse, MvpApiUpdateChargerData, MvpApiUpdateChargerResponse, MvpApiUpdateDeviceData, MvpApiUpdateDeviceResponse, MvpApiUpdateJobData, MvpApiUpdateJobResponse, MvpApiUpdateJobStageData, MvpApiUpdateJobStageResponse, MvpApiUpdateJobTaskMetadataData, MvpApiUpdateJobTaskMetadataResponse, MvpApiUpdatePlanogramLabelData, MvpApiUpdatePlanogramLabelResponse, MvpApiUpdateStoreData, MvpApiUpdateStoreResponse, MvpApiUpdateVideoPropertyDataData, MvpApiUpdateVideoStatusData, MvpApiUpdateVideoTagNameData, MvpApiUpdateVideoTagNameResponse, MvpApiUpdateVideoTagsData, MvpApiUpdateVideoTagsResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const mvpApiListCompaniesQueryKey = (options?: Options<MvpApiListCompaniesData>) => createQueryKey('mvpApiListCompanies', options);

/**
 * List Companies
 */
export const mvpApiListCompaniesOptions = (options?: Options<MvpApiListCompaniesData>) => queryOptions<MvpApiListCompaniesResponse, DefaultError, MvpApiListCompaniesResponse, ReturnType<typeof mvpApiListCompaniesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListCompanies({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListCompaniesQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const mvpApiListCompaniesInfiniteQueryKey = (options?: Options<MvpApiListCompaniesData>): QueryKey<Options<MvpApiListCompaniesData>> => createQueryKey('mvpApiListCompanies', options, true);

/**
 * List Companies
 */
export const mvpApiListCompaniesInfiniteOptions = (options?: Options<MvpApiListCompaniesData>) => infiniteQueryOptions<MvpApiListCompaniesResponse, DefaultError, InfiniteData<MvpApiListCompaniesResponse>, QueryKey<Options<MvpApiListCompaniesData>>, number | Pick<QueryKey<Options<MvpApiListCompaniesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MvpApiListCompaniesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mvpApiListCompanies({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListCompaniesInfiniteQueryKey(options)
});

export const mvpApiGetCompanyQueryKey = (options: Options<MvpApiGetCompanyData>) => createQueryKey('mvpApiGetCompany', options);

/**
 * Get Company
 */
export const mvpApiGetCompanyOptions = (options: Options<MvpApiGetCompanyData>) => queryOptions<MvpApiGetCompanyResponse, DefaultError, MvpApiGetCompanyResponse, ReturnType<typeof mvpApiGetCompanyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiGetCompany({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiGetCompanyQueryKey(options)
});

export const mvpApiListStoresQueryKey = (options?: Options<MvpApiListStoresData>) => createQueryKey('mvpApiListStores', options);

/**
 * List Stores
 */
export const mvpApiListStoresOptions = (options?: Options<MvpApiListStoresData>) => queryOptions<MvpApiListStoresResponse, DefaultError, MvpApiListStoresResponse, ReturnType<typeof mvpApiListStoresQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListStores({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListStoresQueryKey(options)
});

export const mvpApiListStoresInfiniteQueryKey = (options?: Options<MvpApiListStoresData>): QueryKey<Options<MvpApiListStoresData>> => createQueryKey('mvpApiListStores', options, true);

/**
 * List Stores
 */
export const mvpApiListStoresInfiniteOptions = (options?: Options<MvpApiListStoresData>) => infiniteQueryOptions<MvpApiListStoresResponse, DefaultError, InfiniteData<MvpApiListStoresResponse>, QueryKey<Options<MvpApiListStoresData>>, number | Pick<QueryKey<Options<MvpApiListStoresData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MvpApiListStoresData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mvpApiListStores({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListStoresInfiniteQueryKey(options)
});

export const mvpApiGetStoreQueryKey = (options: Options<MvpApiGetStoreData>) => createQueryKey('mvpApiGetStore', options);

/**
 * Get Store
 */
export const mvpApiGetStoreOptions = (options: Options<MvpApiGetStoreData>) => queryOptions<MvpApiGetStoreResponse, DefaultError, MvpApiGetStoreResponse, ReturnType<typeof mvpApiGetStoreQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiGetStore({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiGetStoreQueryKey(options)
});

/**
 * Update Store
 */
export const mvpApiUpdateStoreMutation = (options?: Partial<Options<MvpApiUpdateStoreData>>): UseMutationOptions<MvpApiUpdateStoreResponse, DefaultError, Options<MvpApiUpdateStoreData>> => {
    const mutationOptions: UseMutationOptions<MvpApiUpdateStoreResponse, DefaultError, Options<MvpApiUpdateStoreData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiUpdateStore({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Refresh Store Devices
 */
export const mvpApiRefreshStoreDevicesMutation = (options?: Partial<Options<MvpApiRefreshStoreDevicesData>>): UseMutationOptions<unknown, DefaultError, Options<MvpApiRefreshStoreDevicesData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<MvpApiRefreshStoreDevicesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiRefreshStoreDevices({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiListDevicesQueryKey = (options?: Options<MvpApiListDevicesData>) => createQueryKey('mvpApiListDevices', options);

/**
 * List Devices
 */
export const mvpApiListDevicesOptions = (options?: Options<MvpApiListDevicesData>) => queryOptions<MvpApiListDevicesResponse, DefaultError, MvpApiListDevicesResponse, ReturnType<typeof mvpApiListDevicesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListDevices({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListDevicesQueryKey(options)
});

export const mvpApiListDevicesInfiniteQueryKey = (options?: Options<MvpApiListDevicesData>): QueryKey<Options<MvpApiListDevicesData>> => createQueryKey('mvpApiListDevices', options, true);

/**
 * List Devices
 */
export const mvpApiListDevicesInfiniteOptions = (options?: Options<MvpApiListDevicesData>) => infiniteQueryOptions<MvpApiListDevicesResponse, DefaultError, InfiniteData<MvpApiListDevicesResponse>, QueryKey<Options<MvpApiListDevicesData>>, number | Pick<QueryKey<Options<MvpApiListDevicesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MvpApiListDevicesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mvpApiListDevices({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListDevicesInfiniteQueryKey(options)
});

/**
 * Create Device
 */
export const mvpApiCreateDeviceMutation = (options?: Partial<Options<MvpApiCreateDeviceData>>): UseMutationOptions<MvpApiCreateDeviceResponse, DefaultError, Options<MvpApiCreateDeviceData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCreateDeviceResponse, DefaultError, Options<MvpApiCreateDeviceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiCreateDevice({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Device
 */
export const mvpApiUpdateDeviceMutation = (options?: Partial<Options<MvpApiUpdateDeviceData>>): UseMutationOptions<MvpApiUpdateDeviceResponse, DefaultError, Options<MvpApiUpdateDeviceData>> => {
    const mutationOptions: UseMutationOptions<MvpApiUpdateDeviceResponse, DefaultError, Options<MvpApiUpdateDeviceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiUpdateDevice({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiListDevicePingsQueryKey = (options?: Options<MvpApiListDevicePingsData>) => createQueryKey('mvpApiListDevicePings', options);

/**
 * List Device Pings
 */
export const mvpApiListDevicePingsOptions = (options?: Options<MvpApiListDevicePingsData>) => queryOptions<MvpApiListDevicePingsResponse, DefaultError, MvpApiListDevicePingsResponse, ReturnType<typeof mvpApiListDevicePingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListDevicePings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListDevicePingsQueryKey(options)
});

export const mvpApiListDevicePingsInfiniteQueryKey = (options?: Options<MvpApiListDevicePingsData>): QueryKey<Options<MvpApiListDevicePingsData>> => createQueryKey('mvpApiListDevicePings', options, true);

/**
 * List Device Pings
 */
export const mvpApiListDevicePingsInfiniteOptions = (options?: Options<MvpApiListDevicePingsData>) => infiniteQueryOptions<MvpApiListDevicePingsResponse, DefaultError, InfiniteData<MvpApiListDevicePingsResponse>, QueryKey<Options<MvpApiListDevicePingsData>>, number | Pick<QueryKey<Options<MvpApiListDevicePingsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MvpApiListDevicePingsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mvpApiListDevicePings({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListDevicePingsInfiniteQueryKey(options)
});

export const mvpApiListStorePingsQueryKey = (options?: Options<MvpApiListStorePingsData>) => createQueryKey('mvpApiListStorePings', options);

/**
 * List Store Pings
 */
export const mvpApiListStorePingsOptions = (options?: Options<MvpApiListStorePingsData>) => queryOptions<MvpApiListStorePingsResponse, DefaultError, MvpApiListStorePingsResponse, ReturnType<typeof mvpApiListStorePingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListStorePings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListStorePingsQueryKey(options)
});

export const mvpApiListStorePingsInfiniteQueryKey = (options?: Options<MvpApiListStorePingsData>): QueryKey<Options<MvpApiListStorePingsData>> => createQueryKey('mvpApiListStorePings', options, true);

/**
 * List Store Pings
 */
export const mvpApiListStorePingsInfiniteOptions = (options?: Options<MvpApiListStorePingsData>) => infiniteQueryOptions<MvpApiListStorePingsResponse, DefaultError, InfiniteData<MvpApiListStorePingsResponse>, QueryKey<Options<MvpApiListStorePingsData>>, number | Pick<QueryKey<Options<MvpApiListStorePingsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MvpApiListStorePingsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mvpApiListStorePings({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListStorePingsInfiniteQueryKey(options)
});

export const mvpApiListStorePongsQueryKey = (options?: Options<MvpApiListStorePongsData>) => createQueryKey('mvpApiListStorePongs', options);

/**
 * List Store Pongs
 */
export const mvpApiListStorePongsOptions = (options?: Options<MvpApiListStorePongsData>) => queryOptions<MvpApiListStorePongsResponse, DefaultError, MvpApiListStorePongsResponse, ReturnType<typeof mvpApiListStorePongsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListStorePongs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListStorePongsQueryKey(options)
});

export const mvpApiListStorePongsInfiniteQueryKey = (options?: Options<MvpApiListStorePongsData>): QueryKey<Options<MvpApiListStorePongsData>> => createQueryKey('mvpApiListStorePongs', options, true);

/**
 * List Store Pongs
 */
export const mvpApiListStorePongsInfiniteOptions = (options?: Options<MvpApiListStorePongsData>) => infiniteQueryOptions<MvpApiListStorePongsResponse, DefaultError, InfiniteData<MvpApiListStorePongsResponse>, QueryKey<Options<MvpApiListStorePongsData>>, number | Pick<QueryKey<Options<MvpApiListStorePongsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MvpApiListStorePongsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mvpApiListStorePongs({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListStorePongsInfiniteQueryKey(options)
});

export const mvpApiListCvUpdateRequestsQueryKey = (options?: Options<MvpApiListCvUpdateRequestsData>) => createQueryKey('mvpApiListCvUpdateRequests', options);

/**
 * List Cv Update Requests
 */
export const mvpApiListCvUpdateRequestsOptions = (options?: Options<MvpApiListCvUpdateRequestsData>) => queryOptions<MvpApiListCvUpdateRequestsResponse, DefaultError, MvpApiListCvUpdateRequestsResponse, ReturnType<typeof mvpApiListCvUpdateRequestsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListCvUpdateRequests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListCvUpdateRequestsQueryKey(options)
});

export const mvpApiListCvUpdateRequestsInfiniteQueryKey = (options?: Options<MvpApiListCvUpdateRequestsData>): QueryKey<Options<MvpApiListCvUpdateRequestsData>> => createQueryKey('mvpApiListCvUpdateRequests', options, true);

/**
 * List Cv Update Requests
 */
export const mvpApiListCvUpdateRequestsInfiniteOptions = (options?: Options<MvpApiListCvUpdateRequestsData>) => infiniteQueryOptions<MvpApiListCvUpdateRequestsResponse, DefaultError, InfiniteData<MvpApiListCvUpdateRequestsResponse>, QueryKey<Options<MvpApiListCvUpdateRequestsData>>, number | Pick<QueryKey<Options<MvpApiListCvUpdateRequestsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MvpApiListCvUpdateRequestsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mvpApiListCvUpdateRequests({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListCvUpdateRequestsInfiniteQueryKey(options)
});

export const mvpApiListCvUpdateResponsesQueryKey = (options?: Options<MvpApiListCvUpdateResponsesData>) => createQueryKey('mvpApiListCvUpdateResponses', options);

/**
 * List Cv Update Responses
 */
export const mvpApiListCvUpdateResponsesOptions = (options?: Options<MvpApiListCvUpdateResponsesData>) => queryOptions<MvpApiListCvUpdateResponsesResponse, DefaultError, MvpApiListCvUpdateResponsesResponse, ReturnType<typeof mvpApiListCvUpdateResponsesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListCvUpdateResponses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListCvUpdateResponsesQueryKey(options)
});

export const mvpApiListCvUpdateResponsesInfiniteQueryKey = (options?: Options<MvpApiListCvUpdateResponsesData>): QueryKey<Options<MvpApiListCvUpdateResponsesData>> => createQueryKey('mvpApiListCvUpdateResponses', options, true);

/**
 * List Cv Update Responses
 */
export const mvpApiListCvUpdateResponsesInfiniteOptions = (options?: Options<MvpApiListCvUpdateResponsesData>) => infiniteQueryOptions<MvpApiListCvUpdateResponsesResponse, DefaultError, InfiniteData<MvpApiListCvUpdateResponsesResponse>, QueryKey<Options<MvpApiListCvUpdateResponsesData>>, number | Pick<QueryKey<Options<MvpApiListCvUpdateResponsesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MvpApiListCvUpdateResponsesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mvpApiListCvUpdateResponses({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListCvUpdateResponsesInfiniteQueryKey(options)
});

export const mvpApiCheckDeviceValidityQueryKey = (options: Options<MvpApiCheckDeviceValidityData>) => createQueryKey('mvpApiCheckDeviceValidity', options);

/**
 * Check Device Validity
 */
export const mvpApiCheckDeviceValidityOptions = (options: Options<MvpApiCheckDeviceValidityData>) => queryOptions<MvpApiCheckDeviceValidityResponse, DefaultError, MvpApiCheckDeviceValidityResponse, ReturnType<typeof mvpApiCheckDeviceValidityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiCheckDeviceValidity({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiCheckDeviceValidityQueryKey(options)
});

export const mvpApiListChargersQueryKey = (options?: Options<MvpApiListChargersData>) => createQueryKey('mvpApiListChargers', options);

/**
 * List Chargers
 */
export const mvpApiListChargersOptions = (options?: Options<MvpApiListChargersData>) => queryOptions<MvpApiListChargersResponse, DefaultError, MvpApiListChargersResponse, ReturnType<typeof mvpApiListChargersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListChargers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListChargersQueryKey(options)
});

export const mvpApiListChargersInfiniteQueryKey = (options?: Options<MvpApiListChargersData>): QueryKey<Options<MvpApiListChargersData>> => createQueryKey('mvpApiListChargers', options, true);

/**
 * List Chargers
 */
export const mvpApiListChargersInfiniteOptions = (options?: Options<MvpApiListChargersData>) => infiniteQueryOptions<MvpApiListChargersResponse, DefaultError, InfiniteData<MvpApiListChargersResponse>, QueryKey<Options<MvpApiListChargersData>>, number | Pick<QueryKey<Options<MvpApiListChargersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MvpApiListChargersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mvpApiListChargers({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListChargersInfiniteQueryKey(options)
});

/**
 * Create Charger
 */
export const mvpApiCreateChargerMutation = (options?: Partial<Options<MvpApiCreateChargerData>>): UseMutationOptions<MvpApiCreateChargerResponse, DefaultError, Options<MvpApiCreateChargerData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCreateChargerResponse, DefaultError, Options<MvpApiCreateChargerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiCreateCharger({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Charger
 */
export const mvpApiUpdateChargerMutation = (options?: Partial<Options<MvpApiUpdateChargerData>>): UseMutationOptions<MvpApiUpdateChargerResponse, DefaultError, Options<MvpApiUpdateChargerData>> => {
    const mutationOptions: UseMutationOptions<MvpApiUpdateChargerResponse, DefaultError, Options<MvpApiUpdateChargerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiUpdateCharger({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiListVideoCapturesQueryKey = (options?: Options<MvpApiListVideoCapturesData>) => createQueryKey('mvpApiListVideoCaptures', options);

/**
 * List Video Captures
 */
export const mvpApiListVideoCapturesOptions = (options?: Options<MvpApiListVideoCapturesData>) => queryOptions<MvpApiListVideoCapturesResponse, DefaultError, MvpApiListVideoCapturesResponse, ReturnType<typeof mvpApiListVideoCapturesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListVideoCaptures({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListVideoCapturesQueryKey(options)
});

export const mvpApiListVideoCapturesInfiniteQueryKey = (options?: Options<MvpApiListVideoCapturesData>): QueryKey<Options<MvpApiListVideoCapturesData>> => createQueryKey('mvpApiListVideoCaptures', options, true);

/**
 * List Video Captures
 */
export const mvpApiListVideoCapturesInfiniteOptions = (options?: Options<MvpApiListVideoCapturesData>) => infiniteQueryOptions<MvpApiListVideoCapturesResponse, DefaultError, InfiniteData<MvpApiListVideoCapturesResponse>, QueryKey<Options<MvpApiListVideoCapturesData>>, number | Pick<QueryKey<Options<MvpApiListVideoCapturesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MvpApiListVideoCapturesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mvpApiListVideoCaptures({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListVideoCapturesInfiniteQueryKey(options)
});

export const mvpApiListVideosQueryKey = (options?: Options<MvpApiListVideosData>) => createQueryKey('mvpApiListVideos', options);

/**
 * List Videos
 */
export const mvpApiListVideosOptions = (options?: Options<MvpApiListVideosData>) => queryOptions<MvpApiListVideosResponse, DefaultError, MvpApiListVideosResponse, ReturnType<typeof mvpApiListVideosQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListVideos({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListVideosQueryKey(options)
});

export const mvpApiListVideosInfiniteQueryKey = (options?: Options<MvpApiListVideosData>): QueryKey<Options<MvpApiListVideosData>> => createQueryKey('mvpApiListVideos', options, true);

/**
 * List Videos
 */
export const mvpApiListVideosInfiniteOptions = (options?: Options<MvpApiListVideosData>) => infiniteQueryOptions<MvpApiListVideosResponse, DefaultError, InfiniteData<MvpApiListVideosResponse>, QueryKey<Options<MvpApiListVideosData>>, number | Pick<QueryKey<Options<MvpApiListVideosData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MvpApiListVideosData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mvpApiListVideos({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListVideosInfiniteQueryKey(options)
});

/**
 * Create Video
 */
export const mvpApiCreateVideoMutation = (options?: Partial<Options<MvpApiCreateVideoData>>): UseMutationOptions<unknown, DefaultError, Options<MvpApiCreateVideoData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<MvpApiCreateVideoData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiCreateVideo({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiGetVideoQueryKey = (options: Options<MvpApiGetVideoData>) => createQueryKey('mvpApiGetVideo', options);

/**
 * Get Video
 */
export const mvpApiGetVideoOptions = (options: Options<MvpApiGetVideoData>) => queryOptions<MvpApiGetVideoResponse, DefaultError, MvpApiGetVideoResponse, ReturnType<typeof mvpApiGetVideoQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiGetVideo({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiGetVideoQueryKey(options)
});

/**
 * Update Video Tags
 */
export const mvpApiUpdateVideoTagsMutation = (options?: Partial<Options<MvpApiUpdateVideoTagsData>>): UseMutationOptions<MvpApiUpdateVideoTagsResponse, DefaultError, Options<MvpApiUpdateVideoTagsData>> => {
    const mutationOptions: UseMutationOptions<MvpApiUpdateVideoTagsResponse, DefaultError, Options<MvpApiUpdateVideoTagsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiUpdateVideoTags({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiListVideoExportsQueryKey = (options?: Options<MvpApiListVideoExportsData>) => createQueryKey('mvpApiListVideoExports', options);

/**
 * List Video Exports
 */
export const mvpApiListVideoExportsOptions = (options?: Options<MvpApiListVideoExportsData>) => queryOptions<MvpApiListVideoExportsResponse, DefaultError, MvpApiListVideoExportsResponse, ReturnType<typeof mvpApiListVideoExportsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListVideoExports({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListVideoExportsQueryKey(options)
});

export const mvpApiListVideoExportsInfiniteQueryKey = (options?: Options<MvpApiListVideoExportsData>): QueryKey<Options<MvpApiListVideoExportsData>> => createQueryKey('mvpApiListVideoExports', options, true);

/**
 * List Video Exports
 */
export const mvpApiListVideoExportsInfiniteOptions = (options?: Options<MvpApiListVideoExportsData>) => infiniteQueryOptions<MvpApiListVideoExportsResponse, DefaultError, InfiniteData<MvpApiListVideoExportsResponse>, QueryKey<Options<MvpApiListVideoExportsData>>, number | Pick<QueryKey<Options<MvpApiListVideoExportsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MvpApiListVideoExportsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mvpApiListVideoExports({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListVideoExportsInfiniteQueryKey(options)
});

/**
 * Create Video Export Request
 */
export const mvpApiCreateVideoExportRequestMutation = (options?: Partial<Options<MvpApiCreateVideoExportRequestData>>): UseMutationOptions<MvpApiCreateVideoExportRequestResponse, DefaultError, Options<MvpApiCreateVideoExportRequestData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCreateVideoExportRequestResponse, DefaultError, Options<MvpApiCreateVideoExportRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiCreateVideoExportRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiGetVideoExportRequestQueryKey = (options: Options<MvpApiGetVideoExportRequestData>) => createQueryKey('mvpApiGetVideoExportRequest', options);

/**
 * Get Video Export Request
 */
export const mvpApiGetVideoExportRequestOptions = (options: Options<MvpApiGetVideoExportRequestData>) => queryOptions<MvpApiGetVideoExportRequestResponse, DefaultError, MvpApiGetVideoExportRequestResponse, ReturnType<typeof mvpApiGetVideoExportRequestQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiGetVideoExportRequest({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiGetVideoExportRequestQueryKey(options)
});

/**
 * Register Video Images
 */
export const mvpApiRegisterVideoImagesMutation = (options?: Partial<Options<MvpApiRegisterVideoImagesData>>): UseMutationOptions<unknown, DefaultError, Options<MvpApiRegisterVideoImagesData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<MvpApiRegisterVideoImagesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiRegisterVideoImages({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiListVideoTagNamesQueryKey = (options?: Options<MvpApiListVideoTagNamesData>) => createQueryKey('mvpApiListVideoTagNames', options);

/**
 * List Video Tag Names
 */
export const mvpApiListVideoTagNamesOptions = (options?: Options<MvpApiListVideoTagNamesData>) => queryOptions<MvpApiListVideoTagNamesResponse, DefaultError, MvpApiListVideoTagNamesResponse, ReturnType<typeof mvpApiListVideoTagNamesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListVideoTagNames({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListVideoTagNamesQueryKey(options)
});

export const mvpApiListVideoTagNamesInfiniteQueryKey = (options?: Options<MvpApiListVideoTagNamesData>): QueryKey<Options<MvpApiListVideoTagNamesData>> => createQueryKey('mvpApiListVideoTagNames', options, true);

/**
 * List Video Tag Names
 */
export const mvpApiListVideoTagNamesInfiniteOptions = (options?: Options<MvpApiListVideoTagNamesData>) => infiniteQueryOptions<MvpApiListVideoTagNamesResponse, DefaultError, InfiniteData<MvpApiListVideoTagNamesResponse>, QueryKey<Options<MvpApiListVideoTagNamesData>>, number | Pick<QueryKey<Options<MvpApiListVideoTagNamesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MvpApiListVideoTagNamesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mvpApiListVideoTagNames({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListVideoTagNamesInfiniteQueryKey(options)
});

/**
 * Create Video Tag Name
 */
export const mvpApiCreateVideoTagNameMutation = (options?: Partial<Options<MvpApiCreateVideoTagNameData>>): UseMutationOptions<MvpApiCreateVideoTagNameResponse, DefaultError, Options<MvpApiCreateVideoTagNameData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCreateVideoTagNameResponse, DefaultError, Options<MvpApiCreateVideoTagNameData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiCreateVideoTagName({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiGetVideoTagNameQueryKey = (options: Options<MvpApiGetVideoTagNameData>) => createQueryKey('mvpApiGetVideoTagName', options);

/**
 * Get Video Tag Name
 */
export const mvpApiGetVideoTagNameOptions = (options: Options<MvpApiGetVideoTagNameData>) => queryOptions<MvpApiGetVideoTagNameResponse, DefaultError, MvpApiGetVideoTagNameResponse, ReturnType<typeof mvpApiGetVideoTagNameQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiGetVideoTagName({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiGetVideoTagNameQueryKey(options)
});

/**
 * Update Video Tag Name
 */
export const mvpApiUpdateVideoTagNameMutation = (options?: Partial<Options<MvpApiUpdateVideoTagNameData>>): UseMutationOptions<MvpApiUpdateVideoTagNameResponse, DefaultError, Options<MvpApiUpdateVideoTagNameData>> => {
    const mutationOptions: UseMutationOptions<MvpApiUpdateVideoTagNameResponse, DefaultError, Options<MvpApiUpdateVideoTagNameData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiUpdateVideoTagName({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiListVideoTimeTagsQueryKey = (options?: Options<MvpApiListVideoTimeTagsData>) => createQueryKey('mvpApiListVideoTimeTags', options);

/**
 * List Video Time Tags
 */
export const mvpApiListVideoTimeTagsOptions = (options?: Options<MvpApiListVideoTimeTagsData>) => queryOptions<MvpApiListVideoTimeTagsResponse, DefaultError, MvpApiListVideoTimeTagsResponse, ReturnType<typeof mvpApiListVideoTimeTagsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListVideoTimeTags({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListVideoTimeTagsQueryKey(options)
});

export const mvpApiListVideoTimeTagsInfiniteQueryKey = (options?: Options<MvpApiListVideoTimeTagsData>): QueryKey<Options<MvpApiListVideoTimeTagsData>> => createQueryKey('mvpApiListVideoTimeTags', options, true);

/**
 * List Video Time Tags
 */
export const mvpApiListVideoTimeTagsInfiniteOptions = (options?: Options<MvpApiListVideoTimeTagsData>) => infiniteQueryOptions<MvpApiListVideoTimeTagsResponse, DefaultError, InfiniteData<MvpApiListVideoTimeTagsResponse>, QueryKey<Options<MvpApiListVideoTimeTagsData>>, number | Pick<QueryKey<Options<MvpApiListVideoTimeTagsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MvpApiListVideoTimeTagsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mvpApiListVideoTimeTags({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListVideoTimeTagsInfiniteQueryKey(options)
});

/**
 * Create Video Time Tag
 */
export const mvpApiCreateVideoTimeTagMutation = (options?: Partial<Options<MvpApiCreateVideoTimeTagData>>): UseMutationOptions<MvpApiCreateVideoTimeTagResponse, DefaultError, Options<MvpApiCreateVideoTimeTagData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCreateVideoTimeTagResponse, DefaultError, Options<MvpApiCreateVideoTimeTagData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiCreateVideoTimeTag({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Video Time Tag
 */
export const mvpApiDeleteVideoTimeTagMutation = (options?: Partial<Options<MvpApiDeleteVideoTimeTagData>>): UseMutationOptions<MvpApiDeleteVideoTimeTagResponse, DefaultError, Options<MvpApiDeleteVideoTimeTagData>> => {
    const mutationOptions: UseMutationOptions<MvpApiDeleteVideoTimeTagResponse, DefaultError, Options<MvpApiDeleteVideoTimeTagData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiDeleteVideoTimeTag({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiGetVideoTimeTagQueryKey = (options: Options<MvpApiGetVideoTimeTagData>) => createQueryKey('mvpApiGetVideoTimeTag', options);

/**
 * Get Video Time Tag
 */
export const mvpApiGetVideoTimeTagOptions = (options: Options<MvpApiGetVideoTimeTagData>) => queryOptions<MvpApiGetVideoTimeTagResponse, DefaultError, MvpApiGetVideoTimeTagResponse, ReturnType<typeof mvpApiGetVideoTimeTagQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiGetVideoTimeTag({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiGetVideoTimeTagQueryKey(options)
});

export const mvpApiGetVideoTagsForStoreQueryKey = (options: Options<MvpApiGetVideoTagsForStoreData>) => createQueryKey('mvpApiGetVideoTagsForStore', options);

/**
 * Get Video Tags For Store
 */
export const mvpApiGetVideoTagsForStoreOptions = (options: Options<MvpApiGetVideoTagsForStoreData>) => queryOptions<MvpApiGetVideoTagsForStoreResponse, DefaultError, MvpApiGetVideoTagsForStoreResponse, ReturnType<typeof mvpApiGetVideoTagsForStoreQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiGetVideoTagsForStore({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiGetVideoTagsForStoreQueryKey(options)
});

/**
 * Update Video Status
 */
export const mvpApiUpdateVideoStatusMutation = (options?: Partial<Options<MvpApiUpdateVideoStatusData>>): UseMutationOptions<unknown, DefaultError, Options<MvpApiUpdateVideoStatusData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<MvpApiUpdateVideoStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiUpdateVideoStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Video Property Data
 */
export const mvpApiUpdateVideoPropertyDataMutation = (options?: Partial<Options<MvpApiUpdateVideoPropertyDataData>>): UseMutationOptions<unknown, DefaultError, Options<MvpApiUpdateVideoPropertyDataData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<MvpApiUpdateVideoPropertyDataData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiUpdateVideoPropertyData({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get Image Urls
 */
export const mvpApiGetImageUrlsMutation = (options?: Partial<Options<MvpApiGetImageUrlsData>>): UseMutationOptions<MvpApiGetImageUrlsResponse, DefaultError, Options<MvpApiGetImageUrlsData>> => {
    const mutationOptions: UseMutationOptions<MvpApiGetImageUrlsResponse, DefaultError, Options<MvpApiGetImageUrlsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiGetImageUrls({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get Image Gallery Urls
 */
export const mvpApiGetImageGalleryUrlsMutation = (options?: Partial<Options<MvpApiGetImageGalleryUrlsData>>): UseMutationOptions<MvpApiGetImageGalleryUrlsResponse, DefaultError, Options<MvpApiGetImageGalleryUrlsData>> => {
    const mutationOptions: UseMutationOptions<MvpApiGetImageGalleryUrlsResponse, DefaultError, Options<MvpApiGetImageGalleryUrlsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiGetImageGalleryUrls({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiGetSingleImageUrlsQueryKey = (options: Options<MvpApiGetSingleImageUrlsData>) => createQueryKey('mvpApiGetSingleImageUrls', options);

/**
 * Get Single Image Urls
 */
export const mvpApiGetSingleImageUrlsOptions = (options: Options<MvpApiGetSingleImageUrlsData>) => queryOptions<MvpApiGetSingleImageUrlsResponse, DefaultError, MvpApiGetSingleImageUrlsResponse, ReturnType<typeof mvpApiGetSingleImageUrlsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiGetSingleImageUrls({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiGetSingleImageUrlsQueryKey(options)
});

export const mvpApiGetSignedImageUrlQueryKey = (options: Options<MvpApiGetSignedImageUrlData>) => createQueryKey('mvpApiGetSignedImageUrl', options);

/**
 * Get Signed Image Url
 */
export const mvpApiGetSignedImageUrlOptions = (options: Options<MvpApiGetSignedImageUrlData>) => queryOptions<MvpApiGetSignedImageUrlResponse, DefaultError, MvpApiGetSignedImageUrlResponse, ReturnType<typeof mvpApiGetSignedImageUrlQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiGetSignedImageUrl({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiGetSignedImageUrlQueryKey(options)
});

export const mvpApiGetImageRotationQueryKey = (options: Options<MvpApiGetImageRotationData>) => createQueryKey('mvpApiGetImageRotation', options);

/**
 * Get Image Rotation
 */
export const mvpApiGetImageRotationOptions = (options: Options<MvpApiGetImageRotationData>) => queryOptions<MvpApiGetImageRotationResponse, DefaultError, MvpApiGetImageRotationResponse, ReturnType<typeof mvpApiGetImageRotationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiGetImageRotation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiGetImageRotationQueryKey(options)
});

/**
 * Sign Imgix Url
 */
export const mvpApiSignImgixUrlMutation = (options?: Partial<Options<MvpApiSignImgixUrlData>>): UseMutationOptions<MvpApiSignImgixUrlResponse, DefaultError, Options<MvpApiSignImgixUrlData>> => {
    const mutationOptions: UseMutationOptions<MvpApiSignImgixUrlResponse, DefaultError, Options<MvpApiSignImgixUrlData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiSignImgixUrl({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiListJobsQueryKey = (options?: Options<MvpApiListJobsData>) => createQueryKey('mvpApiListJobs', options);

/**
 * List Jobs
 */
export const mvpApiListJobsOptions = (options?: Options<MvpApiListJobsData>) => queryOptions<MvpApiListJobsResponse, DefaultError, MvpApiListJobsResponse, ReturnType<typeof mvpApiListJobsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListJobs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListJobsQueryKey(options)
});

export const mvpApiListJobsInfiniteQueryKey = (options?: Options<MvpApiListJobsData>): QueryKey<Options<MvpApiListJobsData>> => createQueryKey('mvpApiListJobs', options, true);

/**
 * List Jobs
 */
export const mvpApiListJobsInfiniteOptions = (options?: Options<MvpApiListJobsData>) => infiniteQueryOptions<MvpApiListJobsResponse, DefaultError, InfiniteData<MvpApiListJobsResponse>, QueryKey<Options<MvpApiListJobsData>>, number | Pick<QueryKey<Options<MvpApiListJobsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MvpApiListJobsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mvpApiListJobs({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListJobsInfiniteQueryKey(options)
});

/**
 * Create Job
 */
export const mvpApiCreateJobMutation = (options?: Partial<Options<MvpApiCreateJobData>>): UseMutationOptions<MvpApiCreateJobResponse, DefaultError, Options<MvpApiCreateJobData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCreateJobResponse, DefaultError, Options<MvpApiCreateJobData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiCreateJob({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiListJobsInFlightQueryKey = (options?: Options<MvpApiListJobsInFlightData>) => createQueryKey('mvpApiListJobsInFlight', options);

/**
 * List Jobs In Flight
 */
export const mvpApiListJobsInFlightOptions = (options?: Options<MvpApiListJobsInFlightData>) => queryOptions<MvpApiListJobsInFlightResponse, DefaultError, MvpApiListJobsInFlightResponse, ReturnType<typeof mvpApiListJobsInFlightQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListJobsInFlight({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListJobsInFlightQueryKey(options)
});

export const mvpApiListJobsInFlightInfiniteQueryKey = (options?: Options<MvpApiListJobsInFlightData>): QueryKey<Options<MvpApiListJobsInFlightData>> => createQueryKey('mvpApiListJobsInFlight', options, true);

/**
 * List Jobs In Flight
 */
export const mvpApiListJobsInFlightInfiniteOptions = (options?: Options<MvpApiListJobsInFlightData>) => infiniteQueryOptions<MvpApiListJobsInFlightResponse, DefaultError, InfiniteData<MvpApiListJobsInFlightResponse>, QueryKey<Options<MvpApiListJobsInFlightData>>, number | Pick<QueryKey<Options<MvpApiListJobsInFlightData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MvpApiListJobsInFlightData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mvpApiListJobsInFlight({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListJobsInFlightInfiniteQueryKey(options)
});

/**
 * List Video Jobs
 */
export const mvpApiListVideoJobsMutation = (options?: Partial<Options<MvpApiListVideoJobsData>>): UseMutationOptions<MvpApiListVideoJobsResponse, DefaultError, Options<MvpApiListVideoJobsData>> => {
    const mutationOptions: UseMutationOptions<MvpApiListVideoJobsResponse, DefaultError, Options<MvpApiListVideoJobsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiListVideoJobs({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiGetJobQueryKey = (options: Options<MvpApiGetJobData>) => createQueryKey('mvpApiGetJob', options);

/**
 * Get Job
 */
export const mvpApiGetJobOptions = (options: Options<MvpApiGetJobData>) => queryOptions<MvpApiGetJobResponse, DefaultError, MvpApiGetJobResponse, ReturnType<typeof mvpApiGetJobQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiGetJob({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiGetJobQueryKey(options)
});

/**
 * Update Job
 */
export const mvpApiUpdateJobMutation = (options?: Partial<Options<MvpApiUpdateJobData>>): UseMutationOptions<MvpApiUpdateJobResponse, DefaultError, Options<MvpApiUpdateJobData>> => {
    const mutationOptions: UseMutationOptions<MvpApiUpdateJobResponse, DefaultError, Options<MvpApiUpdateJobData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiUpdateJob({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiGetJobLogTailQueryKey = (options: Options<MvpApiGetJobLogTailData>) => createQueryKey('mvpApiGetJobLogTail', options);

/**
 * Get Job Log Tail
 */
export const mvpApiGetJobLogTailOptions = (options: Options<MvpApiGetJobLogTailData>) => queryOptions<MvpApiGetJobLogTailResponse, DefaultError, MvpApiGetJobLogTailResponse, ReturnType<typeof mvpApiGetJobLogTailQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiGetJobLogTail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiGetJobLogTailQueryKey(options)
});

export const mvpApiGetJobFileQueryKey = (options: Options<MvpApiGetJobFileData>) => createQueryKey('mvpApiGetJobFile', options);

/**
 * Get Job File
 */
export const mvpApiGetJobFileOptions = (options: Options<MvpApiGetJobFileData>) => queryOptions<MvpApiGetJobFileResponse, DefaultError, MvpApiGetJobFileResponse, ReturnType<typeof mvpApiGetJobFileQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiGetJobFile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiGetJobFileQueryKey(options)
});

/**
 * Update Job Stage
 */
export const mvpApiUpdateJobStageMutation = (options?: Partial<Options<MvpApiUpdateJobStageData>>): UseMutationOptions<MvpApiUpdateJobStageResponse, DefaultError, Options<MvpApiUpdateJobStageData>> => {
    const mutationOptions: UseMutationOptions<MvpApiUpdateJobStageResponse, DefaultError, Options<MvpApiUpdateJobStageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiUpdateJobStage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Mark Started Job
 */
export const mvpApiMarkStartedJobMutation = (options?: Partial<Options<MvpApiMarkStartedJobData>>): UseMutationOptions<MvpApiMarkStartedJobResponse, DefaultError, Options<MvpApiMarkStartedJobData>> => {
    const mutationOptions: UseMutationOptions<MvpApiMarkStartedJobResponse, DefaultError, Options<MvpApiMarkStartedJobData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiMarkStartedJob({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Complete Job
 */
export const mvpApiCompleteJobMutation = (options?: Partial<Options<MvpApiCompleteJobData>>): UseMutationOptions<MvpApiCompleteJobResponse, DefaultError, Options<MvpApiCompleteJobData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCompleteJobResponse, DefaultError, Options<MvpApiCompleteJobData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiCompleteJob({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Error Out Job
 */
export const mvpApiErrorOutJobMutation = (options?: Partial<Options<MvpApiErrorOutJobData>>): UseMutationOptions<MvpApiErrorOutJobResponse, DefaultError, Options<MvpApiErrorOutJobData>> => {
    const mutationOptions: UseMutationOptions<MvpApiErrorOutJobResponse, DefaultError, Options<MvpApiErrorOutJobData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiErrorOutJob({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Stop Job
 */
export const mvpApiStopJobMutation = (options?: Partial<Options<MvpApiStopJobData>>): UseMutationOptions<MvpApiStopJobResponse, DefaultError, Options<MvpApiStopJobData>> => {
    const mutationOptions: UseMutationOptions<MvpApiStopJobResponse, DefaultError, Options<MvpApiStopJobData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiStopJob({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Register Images
 */
export const mvpApiRegisterImagesMutation = (options?: Partial<Options<MvpApiRegisterImagesData>>): UseMutationOptions<unknown, DefaultError, Options<MvpApiRegisterImagesData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<MvpApiRegisterImagesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiRegisterImages({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiListJobTasksQueryKey = (options: Options<MvpApiListJobTasksData>) => createQueryKey('mvpApiListJobTasks', options);

/**
 * List Job Tasks
 */
export const mvpApiListJobTasksOptions = (options: Options<MvpApiListJobTasksData>) => queryOptions<MvpApiListJobTasksResponse, DefaultError, MvpApiListJobTasksResponse, ReturnType<typeof mvpApiListJobTasksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListJobTasks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListJobTasksQueryKey(options)
});

/**
 * Create Job Tasks
 */
export const mvpApiCreateJobTasksMutation = (options?: Partial<Options<MvpApiCreateJobTasksData>>): UseMutationOptions<MvpApiCreateJobTasksResponse, DefaultError, Options<MvpApiCreateJobTasksData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCreateJobTasksResponse, DefaultError, Options<MvpApiCreateJobTasksData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiCreateJobTasks({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiGetJobTaskQueryKey = (options: Options<MvpApiGetJobTaskData>) => createQueryKey('mvpApiGetJobTask', options);

/**
 * Get Job Task
 */
export const mvpApiGetJobTaskOptions = (options: Options<MvpApiGetJobTaskData>) => queryOptions<MvpApiGetJobTaskResponse, DefaultError, MvpApiGetJobTaskResponse, ReturnType<typeof mvpApiGetJobTaskQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiGetJobTask({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiGetJobTaskQueryKey(options)
});

export const mvpApiGetJobTaskParcelsQueryKey = (options: Options<MvpApiGetJobTaskParcelsData>) => createQueryKey('mvpApiGetJobTaskParcels', options);

/**
 * Get Job Task Parcels
 */
export const mvpApiGetJobTaskParcelsOptions = (options: Options<MvpApiGetJobTaskParcelsData>) => queryOptions<MvpApiGetJobTaskParcelsResponse, DefaultError, MvpApiGetJobTaskParcelsResponse, ReturnType<typeof mvpApiGetJobTaskParcelsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiGetJobTaskParcels({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiGetJobTaskParcelsQueryKey(options)
});

/**
 * Complete Job Task
 */
export const mvpApiCompleteJobTaskMutation = (options?: Partial<Options<MvpApiCompleteJobTaskData>>): UseMutationOptions<MvpApiCompleteJobTaskResponse, DefaultError, Options<MvpApiCompleteJobTaskData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCompleteJobTaskResponse, DefaultError, Options<MvpApiCompleteJobTaskData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiCompleteJobTask({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Skip Job Task
 */
export const mvpApiSkipJobTaskMutation = (options?: Partial<Options<MvpApiSkipJobTaskData>>): UseMutationOptions<MvpApiSkipJobTaskResponse, DefaultError, Options<MvpApiSkipJobTaskData>> => {
    const mutationOptions: UseMutationOptions<MvpApiSkipJobTaskResponse, DefaultError, Options<MvpApiSkipJobTaskData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiSkipJobTask({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiGetNextPendingJobTaskQueryKey = (options: Options<MvpApiGetNextPendingJobTaskData>) => createQueryKey('mvpApiGetNextPendingJobTask', options);

/**
 * Get Next Pending Job Task
 */
export const mvpApiGetNextPendingJobTaskOptions = (options: Options<MvpApiGetNextPendingJobTaskData>) => queryOptions<MvpApiGetNextPendingJobTaskResponse, DefaultError, MvpApiGetNextPendingJobTaskResponse, ReturnType<typeof mvpApiGetNextPendingJobTaskQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiGetNextPendingJobTask({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiGetNextPendingJobTaskQueryKey(options)
});

export const mvpApiListAllJobTasksQueryKey = (options?: Options<MvpApiListAllJobTasksData>) => createQueryKey('mvpApiListAllJobTasks', options);

/**
 * List All Job Tasks
 */
export const mvpApiListAllJobTasksOptions = (options?: Options<MvpApiListAllJobTasksData>) => queryOptions<MvpApiListAllJobTasksResponse, DefaultError, MvpApiListAllJobTasksResponse, ReturnType<typeof mvpApiListAllJobTasksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListAllJobTasks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListAllJobTasksQueryKey(options)
});

export const mvpApiListAllJobTasksInfiniteQueryKey = (options?: Options<MvpApiListAllJobTasksData>): QueryKey<Options<MvpApiListAllJobTasksData>> => createQueryKey('mvpApiListAllJobTasks', options, true);

/**
 * List All Job Tasks
 */
export const mvpApiListAllJobTasksInfiniteOptions = (options?: Options<MvpApiListAllJobTasksData>) => infiniteQueryOptions<MvpApiListAllJobTasksResponse, DefaultError, InfiniteData<MvpApiListAllJobTasksResponse>, QueryKey<Options<MvpApiListAllJobTasksData>>, number | Pick<QueryKey<Options<MvpApiListAllJobTasksData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MvpApiListAllJobTasksData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mvpApiListAllJobTasks({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListAllJobTasksInfiniteQueryKey(options)
});

/**
 * Update Job Task Metadata
 */
export const mvpApiUpdateJobTaskMetadataMutation = (options?: Partial<Options<MvpApiUpdateJobTaskMetadataData>>): UseMutationOptions<MvpApiUpdateJobTaskMetadataResponse, DefaultError, Options<MvpApiUpdateJobTaskMetadataData>> => {
    const mutationOptions: UseMutationOptions<MvpApiUpdateJobTaskMetadataResponse, DefaultError, Options<MvpApiUpdateJobTaskMetadataData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiUpdateJobTaskMetadata({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Task Activity
 */
export const mvpApiTaskActivityMutation = (options?: Partial<Options<MvpApiTaskActivityData>>): UseMutationOptions<MvpApiTaskActivityResponse, DefaultError, Options<MvpApiTaskActivityData>> => {
    const mutationOptions: UseMutationOptions<MvpApiTaskActivityResponse, DefaultError, Options<MvpApiTaskActivityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiTaskActivity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Review Tasks
 */
export const mvpApiCreateReviewTasksMutation = (options?: Partial<Options<MvpApiCreateReviewTasksData>>): UseMutationOptions<MvpApiCreateReviewTasksResponse, DefaultError, Options<MvpApiCreateReviewTasksData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCreateReviewTasksResponse, DefaultError, Options<MvpApiCreateReviewTasksData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiCreateReviewTasks({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Clone Review Tasks
 */
export const mvpApiCloneReviewTasksMutation = (options?: Partial<Options<MvpApiCloneReviewTasksData>>): UseMutationOptions<MvpApiCloneReviewTasksResponse, DefaultError, Options<MvpApiCloneReviewTasksData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCloneReviewTasksResponse, DefaultError, Options<MvpApiCloneReviewTasksData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiCloneReviewTasks({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Benchmark Jobs
 */
export const mvpApiCreateBenchmarkJobsMutation = (options?: Partial<Options<MvpApiCreateBenchmarkJobsData>>): UseMutationOptions<MvpApiCreateBenchmarkJobsResponse, DefaultError, Options<MvpApiCreateBenchmarkJobsData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCreateBenchmarkJobsResponse, DefaultError, Options<MvpApiCreateBenchmarkJobsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiCreateBenchmarkJobs({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiListMyBenchmarkJobsQueryKey = (options?: Options<MvpApiListMyBenchmarkJobsData>) => createQueryKey('mvpApiListMyBenchmarkJobs', options);

/**
 * List My Benchmark Jobs
 */
export const mvpApiListMyBenchmarkJobsOptions = (options?: Options<MvpApiListMyBenchmarkJobsData>) => queryOptions<MvpApiListMyBenchmarkJobsResponse, DefaultError, MvpApiListMyBenchmarkJobsResponse, ReturnType<typeof mvpApiListMyBenchmarkJobsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListMyBenchmarkJobs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListMyBenchmarkJobsQueryKey(options)
});

export const mvpApiGetBenchmarkJobMetricsQueryKey = (options: Options<MvpApiGetBenchmarkJobMetricsData>) => createQueryKey('mvpApiGetBenchmarkJobMetrics', options);

/**
 * Get Benchmark Job Metrics
 *
 * This quiz's results, for the reviewer who took it or for staff.
 *
 * Unlike /jobs/mine the caller does name a quiz, so ownership is checked rather
 * than implied: a reviewer reaches their own results and nobody else's. Staff
 * and superusers see any quiz — the same people who can create them in the
 * admin. `is_authenticated` is checked first because an internal-API-key caller
 * has an AnonymousUser with no email to compare.
 */
export const mvpApiGetBenchmarkJobMetricsOptions = (options: Options<MvpApiGetBenchmarkJobMetricsData>) => queryOptions<MvpApiGetBenchmarkJobMetricsResponse, DefaultError, MvpApiGetBenchmarkJobMetricsResponse, ReturnType<typeof mvpApiGetBenchmarkJobMetricsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiGetBenchmarkJobMetrics({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiGetBenchmarkJobMetricsQueryKey(options)
});

export const mvpApiListInjectedBenchmarkMetricsQueryKey = (options?: Options<MvpApiListInjectedBenchmarkMetricsData>) => createQueryKey('mvpApiListInjectedBenchmarkMetrics', options);

/**
 * List Injected Benchmark Metrics
 *
 * Per-labeler accuracy over silently injected benchmark tasks (see mvp.benchmark).
 *
 * Staff-only: unlike the announced-quiz metrics above, this covers every
 * labeler at once rather than one reviewer's own quiz. Defaults to the last
 * 30 days when no window is given.
 */
export const mvpApiListInjectedBenchmarkMetricsOptions = (options?: Options<MvpApiListInjectedBenchmarkMetricsData>) => queryOptions<MvpApiListInjectedBenchmarkMetricsResponse, DefaultError, MvpApiListInjectedBenchmarkMetricsResponse, ReturnType<typeof mvpApiListInjectedBenchmarkMetricsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListInjectedBenchmarkMetrics({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListInjectedBenchmarkMetricsQueryKey(options)
});

export const mvpApiGetMyInjectedBenchmarkMetricsQueryKey = (options?: Options<MvpApiGetMyInjectedBenchmarkMetricsData>) => createQueryKey('mvpApiGetMyInjectedBenchmarkMetrics', options);

/**
 * Get My Injected Benchmark Metrics
 *
 * This labeler's own accuracy over silently injected benchmark tasks.
 *
 * Scoped server-side from the authenticated identity, the same rule
 * `benchmark_jobs_for_reviewer` follows — a caller never gets to name whose
 * numbers they see. Zero-filled rather than 404 when the labeler has no
 * injected tasks in the window yet.
 */
export const mvpApiGetMyInjectedBenchmarkMetricsOptions = (options?: Options<MvpApiGetMyInjectedBenchmarkMetricsData>) => queryOptions<MvpApiGetMyInjectedBenchmarkMetricsResponse, DefaultError, MvpApiGetMyInjectedBenchmarkMetricsResponse, ReturnType<typeof mvpApiGetMyInjectedBenchmarkMetricsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiGetMyInjectedBenchmarkMetrics({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiGetMyInjectedBenchmarkMetricsQueryKey(options)
});

export const mvpApiGetInjectionPoolStatusQueryKey = (options?: Options<MvpApiGetInjectionPoolStatusData>) => createQueryKey('mvpApiGetInjectionPoolStatus', options);

/**
 * Get Injection Pool Status
 *
 * Per-store injection pool health: eligible gold candidates and 24h usage.
 *
 * Staff-only operational visibility. With per-store scoping and per-user
 * exclusion, a thin store's pool running dry is the expected early failure
 * mode, not an edge case — without this, an under-filled daily budget is
 * invisible.
 */
export const mvpApiGetInjectionPoolStatusOptions = (options?: Options<MvpApiGetInjectionPoolStatusData>) => queryOptions<MvpApiGetInjectionPoolStatusResponse, DefaultError, MvpApiGetInjectionPoolStatusResponse, ReturnType<typeof mvpApiGetInjectionPoolStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiGetInjectionPoolStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiGetInjectionPoolStatusQueryKey(options)
});

export const mvpApiListToolWebsitesQueryKey = (options?: Options<MvpApiListToolWebsitesData>) => createQueryKey('mvpApiListToolWebsites', options);

/**
 * List Tool Websites
 */
export const mvpApiListToolWebsitesOptions = (options?: Options<MvpApiListToolWebsitesData>) => queryOptions<MvpApiListToolWebsitesResponse, DefaultError, MvpApiListToolWebsitesResponse, ReturnType<typeof mvpApiListToolWebsitesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListToolWebsites({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListToolWebsitesQueryKey(options)
});

export const mvpApiShouldShowStaffToolQueryKey = (options?: Options<MvpApiShouldShowStaffToolData>) => createQueryKey('mvpApiShouldShowStaffTool', options);

/**
 * Should Show Staff Tool
 */
export const mvpApiShouldShowStaffToolOptions = (options?: Options<MvpApiShouldShowStaffToolData>) => queryOptions<MvpApiShouldShowStaffToolResponse, DefaultError, MvpApiShouldShowStaffToolResponse, ReturnType<typeof mvpApiShouldShowStaffToolQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiShouldShowStaffTool({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiShouldShowStaffToolQueryKey(options)
});

export const mvpApiListOosParcelsQueryKey = (options?: Options<MvpApiListOosParcelsData>) => createQueryKey('mvpApiListOosParcels', options);

/**
 * List Oos Parcels
 */
export const mvpApiListOosParcelsOptions = (options?: Options<MvpApiListOosParcelsData>) => queryOptions<MvpApiListOosParcelsResponse, DefaultError, MvpApiListOosParcelsResponse, ReturnType<typeof mvpApiListOosParcelsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListOosParcels({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListOosParcelsQueryKey(options)
});

export const mvpApiListOosParcelsInfiniteQueryKey = (options?: Options<MvpApiListOosParcelsData>): QueryKey<Options<MvpApiListOosParcelsData>> => createQueryKey('mvpApiListOosParcels', options, true);

/**
 * List Oos Parcels
 */
export const mvpApiListOosParcelsInfiniteOptions = (options?: Options<MvpApiListOosParcelsData>) => infiniteQueryOptions<MvpApiListOosParcelsResponse, DefaultError, InfiniteData<MvpApiListOosParcelsResponse>, QueryKey<Options<MvpApiListOosParcelsData>>, number | Pick<QueryKey<Options<MvpApiListOosParcelsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MvpApiListOosParcelsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mvpApiListOosParcels({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListOosParcelsInfiniteQueryKey(options)
});

export const mvpApiGetOosParcelQueryKey = (options: Options<MvpApiGetOosParcelData>) => createQueryKey('mvpApiGetOosParcel', options);

/**
 * Get Oos Parcel
 */
export const mvpApiGetOosParcelOptions = (options: Options<MvpApiGetOosParcelData>) => queryOptions<MvpApiGetOosParcelResponse, DefaultError, MvpApiGetOosParcelResponse, ReturnType<typeof mvpApiGetOosParcelQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiGetOosParcel({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiGetOosParcelQueryKey(options)
});

export const mvpApiListOosEventBufferQueryKey = (options?: Options<MvpApiListOosEventBufferData>) => createQueryKey('mvpApiListOosEventBuffer', options);

/**
 * List Oos Event Buffer
 */
export const mvpApiListOosEventBufferOptions = (options?: Options<MvpApiListOosEventBufferData>) => queryOptions<MvpApiListOosEventBufferResponse, DefaultError, MvpApiListOosEventBufferResponse, ReturnType<typeof mvpApiListOosEventBufferQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListOosEventBuffer({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListOosEventBufferQueryKey(options)
});

export const mvpApiListOosEventBufferInfiniteQueryKey = (options?: Options<MvpApiListOosEventBufferData>): QueryKey<Options<MvpApiListOosEventBufferData>> => createQueryKey('mvpApiListOosEventBuffer', options, true);

/**
 * List Oos Event Buffer
 */
export const mvpApiListOosEventBufferInfiniteOptions = (options?: Options<MvpApiListOosEventBufferData>) => infiniteQueryOptions<MvpApiListOosEventBufferResponse, DefaultError, InfiniteData<MvpApiListOosEventBufferResponse>, QueryKey<Options<MvpApiListOosEventBufferData>>, number | Pick<QueryKey<Options<MvpApiListOosEventBufferData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MvpApiListOosEventBufferData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mvpApiListOosEventBuffer({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListOosEventBufferInfiniteQueryKey(options)
});

export const mvpApiGetOosEventFromBufferQueryKey = (options: Options<MvpApiGetOosEventFromBufferData>) => createQueryKey('mvpApiGetOosEventFromBuffer', options);

/**
 * Get Oos Event From Buffer
 */
export const mvpApiGetOosEventFromBufferOptions = (options: Options<MvpApiGetOosEventFromBufferData>) => queryOptions<MvpApiGetOosEventFromBufferResponse, DefaultError, MvpApiGetOosEventFromBufferResponse, ReturnType<typeof mvpApiGetOosEventFromBufferQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiGetOosEventFromBuffer({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiGetOosEventFromBufferQueryKey(options)
});

export const mvpApiListOosEventBatchesQueryKey = (options?: Options<MvpApiListOosEventBatchesData>) => createQueryKey('mvpApiListOosEventBatches', options);

/**
 * List Oos Event Batches
 */
export const mvpApiListOosEventBatchesOptions = (options?: Options<MvpApiListOosEventBatchesData>) => queryOptions<MvpApiListOosEventBatchesResponse, DefaultError, MvpApiListOosEventBatchesResponse, ReturnType<typeof mvpApiListOosEventBatchesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListOosEventBatches({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListOosEventBatchesQueryKey(options)
});

export const mvpApiListOosEventBatchesInfiniteQueryKey = (options?: Options<MvpApiListOosEventBatchesData>): QueryKey<Options<MvpApiListOosEventBatchesData>> => createQueryKey('mvpApiListOosEventBatches', options, true);

/**
 * List Oos Event Batches
 */
export const mvpApiListOosEventBatchesInfiniteOptions = (options?: Options<MvpApiListOosEventBatchesData>) => infiniteQueryOptions<MvpApiListOosEventBatchesResponse, DefaultError, InfiniteData<MvpApiListOosEventBatchesResponse>, QueryKey<Options<MvpApiListOosEventBatchesData>>, number | Pick<QueryKey<Options<MvpApiListOosEventBatchesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MvpApiListOosEventBatchesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mvpApiListOosEventBatches({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListOosEventBatchesInfiniteQueryKey(options)
});

export const mvpApiGetOosEventBatchQueryKey = (options: Options<MvpApiGetOosEventBatchData>) => createQueryKey('mvpApiGetOosEventBatch', options);

/**
 * Get Oos Event Batch
 */
export const mvpApiGetOosEventBatchOptions = (options: Options<MvpApiGetOosEventBatchData>) => queryOptions<MvpApiGetOosEventBatchResponse, DefaultError, MvpApiGetOosEventBatchResponse, ReturnType<typeof mvpApiGetOosEventBatchQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiGetOosEventBatch({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiGetOosEventBatchQueryKey(options)
});

export const mvpApiListPlanogramsQueryKey = (options?: Options<MvpApiListPlanogramsData>) => createQueryKey('mvpApiListPlanograms', options);

/**
 * List Planograms
 */
export const mvpApiListPlanogramsOptions = (options?: Options<MvpApiListPlanogramsData>) => queryOptions<MvpApiListPlanogramsResponse, DefaultError, MvpApiListPlanogramsResponse, ReturnType<typeof mvpApiListPlanogramsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListPlanograms({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListPlanogramsQueryKey(options)
});

export const mvpApiListPlanogramsInfiniteQueryKey = (options?: Options<MvpApiListPlanogramsData>): QueryKey<Options<MvpApiListPlanogramsData>> => createQueryKey('mvpApiListPlanograms', options, true);

/**
 * List Planograms
 */
export const mvpApiListPlanogramsInfiniteOptions = (options?: Options<MvpApiListPlanogramsData>) => infiniteQueryOptions<MvpApiListPlanogramsResponse, DefaultError, InfiniteData<MvpApiListPlanogramsResponse>, QueryKey<Options<MvpApiListPlanogramsData>>, number | Pick<QueryKey<Options<MvpApiListPlanogramsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MvpApiListPlanogramsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mvpApiListPlanograms({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListPlanogramsInfiniteQueryKey(options)
});

/**
 * Create Planogram
 */
export const mvpApiCreatePlanogramMutation = (options?: Partial<Options<MvpApiCreatePlanogramData>>): UseMutationOptions<MvpApiCreatePlanogramResponse, DefaultError, Options<MvpApiCreatePlanogramData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCreatePlanogramResponse, DefaultError, Options<MvpApiCreatePlanogramData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiCreatePlanogram({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiGetPlanogramQueryKey = (options: Options<MvpApiGetPlanogramData>) => createQueryKey('mvpApiGetPlanogram', options);

/**
 * Get Planogram
 */
export const mvpApiGetPlanogramOptions = (options: Options<MvpApiGetPlanogramData>) => queryOptions<MvpApiGetPlanogramResponse, DefaultError, MvpApiGetPlanogramResponse, ReturnType<typeof mvpApiGetPlanogramQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiGetPlanogram({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiGetPlanogramQueryKey(options)
});

export const mvpApiGetPlanogramLabelQueryKey = (options: Options<MvpApiGetPlanogramLabelData>) => createQueryKey('mvpApiGetPlanogramLabel', options);

/**
 * Get Planogram Label
 */
export const mvpApiGetPlanogramLabelOptions = (options: Options<MvpApiGetPlanogramLabelData>) => queryOptions<MvpApiGetPlanogramLabelResponse, DefaultError, MvpApiGetPlanogramLabelResponse, ReturnType<typeof mvpApiGetPlanogramLabelQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiGetPlanogramLabel({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiGetPlanogramLabelQueryKey(options)
});

/**
 * Update Planogram Label
 */
export const mvpApiUpdatePlanogramLabelMutation = (options?: Partial<Options<MvpApiUpdatePlanogramLabelData>>): UseMutationOptions<MvpApiUpdatePlanogramLabelResponse, DefaultError, Options<MvpApiUpdatePlanogramLabelData>> => {
    const mutationOptions: UseMutationOptions<MvpApiUpdatePlanogramLabelResponse, DefaultError, Options<MvpApiUpdatePlanogramLabelData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiUpdatePlanogramLabel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiListPlanogramImagesQueryKey = (options: Options<MvpApiListPlanogramImagesData>) => createQueryKey('mvpApiListPlanogramImages', options);

/**
 * List Planogram Images
 */
export const mvpApiListPlanogramImagesOptions = (options: Options<MvpApiListPlanogramImagesData>) => queryOptions<MvpApiListPlanogramImagesResponse, DefaultError, MvpApiListPlanogramImagesResponse, ReturnType<typeof mvpApiListPlanogramImagesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListPlanogramImages({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListPlanogramImagesQueryKey(options)
});

/**
 * Create Planogram Images
 */
export const mvpApiCreatePlanogramImagesMutation = (options?: Partial<Options<MvpApiCreatePlanogramImagesData>>): UseMutationOptions<MvpApiCreatePlanogramImagesResponse, DefaultError, Options<MvpApiCreatePlanogramImagesData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCreatePlanogramImagesResponse, DefaultError, Options<MvpApiCreatePlanogramImagesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiCreatePlanogramImages({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiGetPlanogramImageQueryKey = (options: Options<MvpApiGetPlanogramImageData>) => createQueryKey('mvpApiGetPlanogramImage', options);

/**
 * Get Planogram Image
 */
export const mvpApiGetPlanogramImageOptions = (options: Options<MvpApiGetPlanogramImageData>) => queryOptions<MvpApiGetPlanogramImageResponse, DefaultError, MvpApiGetPlanogramImageResponse, ReturnType<typeof mvpApiGetPlanogramImageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiGetPlanogramImage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiGetPlanogramImageQueryKey(options)
});

export const mvpApiGetStoresInventoryQueryKey = (options?: Options<MvpApiGetStoresInventoryData>) => createQueryKey('mvpApiGetStoresInventory', options);

/**
 * Get Stores Inventory
 */
export const mvpApiGetStoresInventoryOptions = (options?: Options<MvpApiGetStoresInventoryData>) => queryOptions<MvpApiGetStoresInventoryResponse, DefaultError, MvpApiGetStoresInventoryResponse, ReturnType<typeof mvpApiGetStoresInventoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiGetStoresInventory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiGetStoresInventoryQueryKey(options)
});

export const mvpApiGetDevicesInventoryQueryKey = (options?: Options<MvpApiGetDevicesInventoryData>) => createQueryKey('mvpApiGetDevicesInventory', options);

/**
 * Get Devices Inventory
 */
export const mvpApiGetDevicesInventoryOptions = (options?: Options<MvpApiGetDevicesInventoryData>) => queryOptions<MvpApiGetDevicesInventoryResponse, DefaultError, MvpApiGetDevicesInventoryResponse, ReturnType<typeof mvpApiGetDevicesInventoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiGetDevicesInventory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiGetDevicesInventoryQueryKey(options)
});
